<template>
  <div>
    <!-- loading -->
    <LoadingSpinner v-if="!isLoading" />
    <div v-else>
      <div
        class="col-md-6 my-2"
        v-if="hasPermissions('superAdmin') && userSelectedIsBdrUser"
      >
        <div class="form-group">
          <label class="font-weight-bold d-block text-left mb-2">Primary {{ $t("lang.label.clients") }}</label>
          <treeselect
            v-model="primaryClientBdrIds"
            :options="filterClientsByOtherPriorities(primaryClientBdrIds)"
            :multiple="true"
            :searchable="true"
            :clearable="true"
            :loading="isLoading"
            placeholder="Search clients"
            label="label"
            track-by="id"
          >
          </treeselect>
        </div>
      </div>

      <div
        class="col-md-6 my-2"
        v-if="hasPermissions('superAdmin') && userSelectedIsBdrUser"
      >
        <div class="form-group">
          <label class="font-weight-bold d-block text-left mb-2">Secondary {{ $t("lang.label.clients") }}</label>
          <treeselect
            v-model="secondaryClientBdrIds"
            :options="filterClientsByOtherPriorities(secondaryClientBdrIds)"
            :multiple="true"
            :searchable="true"
            :clearable="true"
            :loading="isLoading"
            placeholder="Search clients"
            label="label"
            track-by="id"
          >
          </treeselect>
        </div>
      </div>

      <div
        class="col-md-6 my-2"
        v-if="hasPermissions('superAdmin') && userSelectedIsBdrUser"
      >
        <div class="form-group">
          <label class="font-weight-bold d-block text-left mb-2">Tertiary {{ $t("lang.label.clients") }}</label>
          <treeselect
            v-model="tertiaryClientBdrIds"
            :options="filterClientsByOtherPriorities(tertiaryClientBdrIds)"
            :multiple="true"
            :searchable="true"
            :clearable="true"
            :loading="isLoading"
            placeholder="Search clients"
            label="label"
            track-by="id"
          >
          </treeselect>
        </div>
      </div>

      <div
        class="col-md-8 my-3"
        v-if="hasPermissions('superAdmin') && userSelectedIsBdrUser && selectedClientsForCupo.length"
      >
        <label class="font-weight-bold d-block text-left mb-2">
          {{ $t("lang.label.max_cold_tasks_per_day") }}
          <small class="text-muted font-weight-normal">{{ $t("lang.label.max_cold_tasks_per_day_hint") }}</small>
        </label>
        <table class="table table-sm table-bordered mb-0">
          <thead>
            <tr>
              <th>{{ $t("lang.column.client") }}</th>
              <th style="width: 90px">{{ $t("lang.label.priority") }}</th>
              <th style="width: 160px">{{ $t("lang.label.max_per_day") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in selectedClientsForCupo" :key="row.id">
              <td>{{ row.label }}</td>
              <td>{{ row.priorityLabel }}</td>
              <td>
                <input
                  type="number"
                  min="1"
                  class="form-control form-control-sm"
                  :value="
                    clientMaxTasks[row.id] == null || clientMaxTasks[row.id] === ''
                      ? defaultMaxTasksPerDay
                      : clientMaxTasks[row.id]
                  "
                  @input="onMaxTasksInput(row.id, $event.target.value)"
                  :placeholder="String(defaultMaxTasksPerDay)"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- <div class="col-md-6 my-2" v-if="userSelectedIsBdrUser">
        <h5 class="my-2 font-weight-bold">{{ $t("lang.column.targets") }} :</h5>
        <treeselect
          v-model="selected.user.bdr_target_ids"
          :options="filteredTargets"
          :multiple="true"
        >
        </treeselect>
      </div> -->

      <div class="col-md-6 my-2" v-if="userSelectedIsBdrUser">
        <h5 class="my-2 font-weight-bold">
          {{ $t("lang.label.language_spoken") }} :
        </h5>
        <treeselect
          v-model="selected.user.spoken_language_ids"
          :options="spokenLangs"
          :multiple="true"
        >
        </treeselect>
      </div>

      <div class="col-md-6 mt-2" v-if="userSelectedIsBdrUser">
        <div class="form-group">
          <h5 class="my-2 font-weight-bold">
            {{ $t("lang.label.manager_temperature") }} :
          </h5>
          <treeselect
            v-model="selected.user.link_temperatures_ids"
            :options="temperatureStatuseOptions"
            :multiple="true"
          >
          </treeselect>
        </div>
      </div>

      <div class="col-md-12">
        <button
          @click="saveLeadroomConfig()"
          class="btn btn-primary w-25 font-weight-bold rounded-pill"
        >
          {{ $t("lang.button.update") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Treeselect from "@riophae/vue-treeselect";
import { monitorService, bookersService, usersService } from "@/_services";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import { mapState } from "vuex";
export default {
  components: {
    Treeselect,
    LoadingSpinner,
  },
  props: {
    selected: {
      type: Object,
    },
    selectedUserId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      isLoading: false,
      model_client_ids: [],
      filteredClients: [],
      clients: [],
      spokenLangs: [],
      filteredTargets: [],
      primaryClientBdrIds: [],
      secondaryClientBdrIds: [],
      tertiaryClientBdrIds: [],
      clientMaxTasks: {},
      defaultMaxTasksPerDay: 50,
      temperatureStatuseOptions: [
        { id: "1", label: "Urgent" },
        { id: "2", label: "Positive" },
        { id: "3", label: "Introduction" },
        { id: "4", label: "Wrong contact" },
        { id: "5", label: "Negative" },
        { id: "6", label: "Calendar inspection" },
        { id: "7", label: "Reschedule" },
        { id: "8", label: "Cold" },
        { id: "9", label: "Other Answer" },
      ],
    };
  },
  computed: {
    ...mapState({
      Languages: (state) => state.optionsList.all["languages"].data,
    }),
    userSelectedIsBdrUser() {
      return this.selected.user.team_role_id == 2 &&
        this.selected.user.role_id == 2
        ? true
        : false;
    },
    selectedClientsForCupo() {
      const rows = [];
      const pushRows = (ids, priorityLabel) => {
        (ids || []).forEach((id) => {
          const clientId = String(id);
          const match = (this.clients || []).find((c) => String(c.id) === clientId);
          rows.push({
            id: clientId,
            label: match && match.label ? match.label : `ID: ${clientId}`,
            priorityLabel,
          });
        });
      };
      pushRows(this.primaryClientBdrIds, this.$t("lang.label.client_priority_primary"));
      pushRows(this.secondaryClientBdrIds, this.$t("lang.label.client_priority_secondary"));
      pushRows(this.tertiaryClientBdrIds, this.$t("lang.label.client_priority_tertiary"));
      return rows;
    },
  },
  created(){
    this.selected.user.link_temperatures_ids = this.selected.user.link_temperatures_ids == [] ? ['8'] : this.selected.user.link_temperatures_ids;
    this.selected.user.spoken_language_ids = this.selected.user.spoken_language_ids == [] ? ['1'] : this.selected.user.spoken_language_ids;

    this.getClients();
    this.$store.dispatch("optionsList/getLanguages").then(() => {
      this.langs = this.Languages.filter((el, i) => i < 4);
        this.spokenLangs = this.Languages
          .filter((el, i) => i < 4)
          .map((el) => ({ id: el.id, label: el.name }));
        this.isLoading = true;
    });
    
    // Load client priorities from backend data (if available)
    const rawClientPriorities = this.selected.user.client_bdr_priority;
    const parsedClientPriorities = this.parseClientPrioritiesRaw(rawClientPriorities);
    
    if (parsedClientPriorities.length > 0) {
      // Organize clients by priority + restore daily cupos
      parsedClientPriorities.forEach((clientItem) => {
        const clientId = String(clientItem.client_id || "").trim();
        const priority = this.getEffectivePriority(clientItem.priority);
        
        if (priority === 1) this.primaryClientBdrIds.push(clientId);
        else if (priority === 2) this.secondaryClientBdrIds.push(clientId);
        else this.tertiaryClientBdrIds.push(clientId);

        const maxTasks = clientItem.max_tasks_per_day;
        const parsedMax = Number(maxTasks);
        this.$set(
          this.clientMaxTasks,
          clientId,
          Number.isFinite(parsedMax) && parsedMax > 0
            ? parsedMax
            : this.defaultMaxTasksPerDay
        );
      });
    } else if (this.selected.user.client_bdr_ids && this.selected.user.client_bdr_ids.length > 0) {
      // Fallback to legacy flat list (all as primary)
      this.primaryClientBdrIds = [...this.selected.user.client_bdr_ids];
    }
    
    const allClientIds = [...new Set([...this.primaryClientBdrIds, ...this.secondaryClientBdrIds, ...this.tertiaryClientBdrIds])];
    if (allClientIds.length > 0) {
      this.getTargetsActives(allClientIds);
    }
  },
  methods: {
    hasPermissions(perm) {
      return this.$store.getters["authentication/hasPermissions"](perm);
    },
    getEffectivePriority(priority) {
      const parsed = Number(priority);
      if ([1, 2, 3].includes(parsed)) return parsed;
      return 1;
    },
    onMaxTasksInput(clientId, rawValue) {
      const trimmed = String(rawValue == null ? "" : rawValue).trim();
      if (trimmed === "") {
        this.$set(this.clientMaxTasks, clientId, this.defaultMaxTasksPerDay);
        return;
      }
      const parsed = parseInt(trimmed, 10);
      this.$set(
        this.clientMaxTasks,
        clientId,
        Number.isFinite(parsed) && parsed > 0
          ? parsed
          : this.defaultMaxTasksPerDay
      );
    },
    buildClientMaxTasksPayload(allClientIds) {
      const payload = {};
      allClientIds.forEach((id) => {
        const key = String(id);
        const value = this.clientMaxTasks[key];
        if (value === null || value === undefined || value === "") {
          payload[key] = this.defaultMaxTasksPerDay;
          return;
        }
        const parsed = parseInt(value, 10);
        payload[key] =
          Number.isFinite(parsed) && parsed > 0
            ? parsed
            : this.defaultMaxTasksPerDay;
      });
      return payload;
    },
    getClients() {
      this.isLoading = false;
      const toCreateUser = 1;
      monitorService
        .getClients(null, "3,4,5,7,8", toCreateUser)
        .then((res) => {
          this.clients = res;
          if (
            this.selected &&
            this.selected.user &&
            this.selected.user.client_bdr_ids
          ) {
            this.model_client_ids = this.selected.user.client_bdr_ids;
            this.filteredClients = this.clients.filter((client) =>
              this.model_client_ids.includes(client.id)
            );
          }
        })
        .catch((err) => console.log(err));
    },
    getTargetsActives(clients_bdr_ids) {
      if (clients_bdr_ids && clients_bdr_ids.length > 0) {
        usersService
          .getTargetActiveByClients(clients_bdr_ids)
          .then((response) => {
            this.filteredTargets = response;

                    this.filteredTargets = response.map(opt => {
          return {
            ...opt,
            label: opt.should_call_target === '0' ? '❌ ' + opt.label : '✅ ' + opt.label 
          };
        });
          });
      }
    },
    onSearchChange(searchQuery) {
      console.log(searchQuery)
      if (searchQuery.length > 0) {
        const query = searchQuery.toLowerCase();
        this.filteredClients = this.clients.filter((client) =>
          client.label.toLowerCase().includes(query)
        );
      } else {
        this.filteredClients = [];
      }
    },
    filterClientsByOtherPriorities(keepSelected = []) {
      const allSelectedClientIds = new Set([
        ...(this.primaryClientBdrIds || []),
        ...(this.secondaryClientBdrIds || []),
        ...(this.tertiaryClientBdrIds || []),
      ]);
      
      (keepSelected || []).forEach((id) => allSelectedClientIds.delete(id));
      
      return this.clients.filter((client) => !allSelectedClientIds.has(client.id));
    },
    getClientPriorityBadge(priority) {
      const parsed = Number(priority);
      if (parsed === 1) return "[P]";
      if (parsed === 2) return "[S]";
      return "[T]";
    },
    parseClientPrioritiesRaw(rawClientPriorities) {
      if (!rawClientPriorities) return [];
      
      if (Array.isArray(rawClientPriorities)) {
        return rawClientPriorities;
      }
      
      if (typeof rawClientPriorities === "object") {
        return [rawClientPriorities];
      }
      
      if (typeof rawClientPriorities !== "string") return [];
      
      const trimmed = rawClientPriorities.trim();
      if (!trimmed) return [];
      
      if (trimmed.startsWith("[") || trimmed.startsWith("{")) {
        try {
          const parsed = JSON.parse(trimmed);
          return Array.isArray(parsed) ? parsed : [];
        } catch (e) {
          return [];
        }
      }
      
      return trimmed
        .split(";;")
        .map((entry) => entry.trim())
        .filter(Boolean)
        .map((entry) => {
          const [id, label = "", priorityValue = "", maxTasksValue = ""] = entry.split("|");
          const normalizedPriority = String(priorityValue).trim();
          const normalizedMax = String(maxTasksValue).trim();
          return {
            client_id: id ? String(id).trim() : "",
            label: String(label).trim(),
            priority: normalizedPriority === "" ? null : Number(normalizedPriority),
            max_tasks_per_day: normalizedMax === "" ? null : Number(normalizedMax),
          };
        })
        .filter((item) => item.client_id !== "");
    },
    saveLeadroomConfig() {
      const primaryClientIds = (this.primaryClientBdrIds || []).map(String).filter(Boolean);
      const secondaryClientIds = (this.secondaryClientBdrIds || []).map(String).filter(Boolean);
      const tertiaryClientIds = (this.tertiaryClientBdrIds || []).map(String).filter(Boolean);
      const allClientIds = [...new Set([...primaryClientIds, ...secondaryClientIds, ...tertiaryClientIds])];
      
      const payload = {
        primary_client_ids: primaryClientIds,
        secondary_client_ids: secondaryClientIds,
        tertiary_client_ids: tertiaryClientIds,
        bdr_client_ids: allClientIds,
        // Always resend cupos (DELETE+INSERT on backend would wipe them otherwise)
        client_max_tasks: this.buildClientMaxTasksPayload(allClientIds),
      };
      
      bookersService
        .saveLeadroomConfig(
          this.selectedUserId,
          payload,
          this.selected.user.bdr_target_ids,
          this.selected.user.spoken_language_ids,
          this.selected.user.link_temperatures_ids
        )
        .then((res) => {
          this.$swal({
            type: "success",
            title: this.$t("lang.label.great"),
            text: this.$t("lang.label.datasavedsuccessfully"),
            showConfirmButton: false,
            timer: 5000,
          });
        })
        .then(() => {
          this.$emit("getUser");
        })
        .catch((err) => {
          const conflictingIds = Array.isArray(err && err.conflicting_client_ids)
            ? err.conflicting_client_ids
            : [];

          if (conflictingIds.length > 0) {
            const conflictingClients = conflictingIds.map((id) => {
              const match = this.clients.find(
                (c) => String(c.id) === String(id)
              );
              return match && match.label
                ? `${match.label} (ID: ${id})`
                : `ID: ${id}`;
            });

            this.$swal({
              type: "error",
              title: this.$t("lang.label.error"),
              html: `${this.$t(
                "lang.label.conflictingClientsAlreadyAssigned"
              )}<br><br><strong>${conflictingClients.join("<br>")}</strong>`,
              showConfirmButton: true,
            });
            return;
          }

          this.$swal({
            type: "error",
            title: this.$t("lang.label.error"),
            text: (err && err.error) || "",
            showConfirmButton: true,
          });
        });
    },
  },
};
</script>

<style></style>
